const monitors = [];
let monitorsLoaded = false;

function getAvailableMonitors({ allMonitors = [] } = {}) {
  if ((!allMonitors.length && monitors.length) || monitorsLoaded) {
    return monitors;
  }

  allMonitors.forEach(monitor => {
    if (typeof monitor.isConfigured === 'function' && monitor.isConfigured() && monitor.isValid()) {
      monitors.push(monitor);
    }
  });

  monitorsLoaded = true;
  return monitors;
}

module.exports = getAvailableMonitors;
